import { useEffect, useState } from "react";

/* Has the viewer scrolled past this element? */
export const useScrolledPast = (ref) => {
  const [past, setPast] = useState(false);

  useEffect(() => {
    const read = () => {
      const node = ref?.current;
      if (!node) return;
      const rect = node.getBoundingClientRect();
      /* An unmeasured element reports all zeros — in jsdom, and in a real browser for one frame before layout. */
      if (rect.height === 0) return;
      setPast(rect.bottom <= 0);
    };

    read();
    window.addEventListener("scroll", read, { passive: true });
    window.addEventListener("resize", read);
    return () => {
      window.removeEventListener("scroll", read);
      window.removeEventListener("resize", read);
    };
  }, [ref]);

  return past;
};

export default useScrolledPast;
